import {getInvertryData} from "../../data-services/data-service";
import {useAppSelector} from "../../data-services/store";
import {useEffect, useState} from "react";

/**
 * the entry point
 */
const PRDIsInventory: React.FC = () => {
    const productsRelDocsInitialSelected = useAppSelector((store) => store.productsRelDocsInitialSelected);
    const [ResultObject, setResultObject] = useState<any>();

    useEffect(() => {
        (async () => {
            const response = await getInvertryData(productsRelDocsInitialSelected.nodeGUID);
            if(!response || response.statusCode !== 200 || !response.data.resultStatus) {
                //setError(response.data as unknown as ModelServerErrors);
                return;
            }
            setResultObject(response.data.resultObject);
        })();
    }, [productsRelDocsInitialSelected.nodeGUID]);

    return (
        <div className="w-full mt-4">
            {
                <>
                    <div className="text-left text-yellow-400">
                        {ResultObject} Units Available at This Price
                    </div>

                </>
            }
        </div>
    )
};

export default PRDIsInventory;